/**
 * Markdown 编辑器组件
 * 提供所见即所得的 Markdown 编辑体验，支持实时预览
 */

import { memo } from 'react';
import MDEditor from '@uiw/react-md-editor';
import '@uiw/react-md-editor/markdown-editor.css';
import './markdown-editor-custom.css';

interface MarkdownEditorProps {
  /** Markdown 内容 */
  value: string;
  /** 内容变化回调 */
  onChange: (value: string | undefined) => void;
  /** 编辑器高度（像素） */
  height?: number;
  /** 是否只读 */
  readonly?: boolean;
  /** 占位符文本 */
  placeholder?: string;
  /** 额外的 CSS 类名 */
  className?: string;
}

/**
 * Markdown 编辑器
 *
 * 功能特性：
 * - 实时预览
 * - 工具栏快捷操作
 * - 支持快捷键
 * - 暗色模式支持
 * - 支持表格、代码高亮等高级语法
 *
 * @example
 * ```tsx
 * <MarkdownEditor
 *   value={markdown}
 *   onChange={(value) => setMarkdown(value || '')}
 *   height={400}
 * />
 * ```
 */
export const MarkdownEditor = memo(
  ({ value, onChange, height = 400, readonly = false, placeholder = '请输入 Markdown 内容...', className = '' }: MarkdownEditorProps) => {
    return (
      <div className={className} data-color-mode="light">
        <MDEditor
          value={value}
          onChange={onChange}
          height={height}
          preview="live"
          textareaProps={{
            placeholder,
            disabled: readonly,
          }}
          visibleDragbar={false}
          extraCommands={[]}
        />
      </div>
    );
  }
);

MarkdownEditor.displayName = 'MarkdownEditor';
